import { createAction, createAsyncAction } from "typesafe-actions";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type { Profile } from "../types/common";
import type { ProfilesResponseDto } from "../types/dto";

export const profilesResultsClearedAction = createAction("@@si/contacts-search-profiles/results-cleared")();

export const resetCreatedProfileAction = createAction("@@si/contacts-search-profiles/reset-created-profile")();

export const fetchProfilesAsync = createAsyncAction(
    "@@si/contacts-search-profiles/fetch-all-started",
    "@@si/contacts-search-profiles/fetch-all-succeeded",
    "@@si/contacts-search-profiles/fetch-all-failed",
)<void, ProfilesResponseDto, FetchError>();

export const createProfileAsync = createAsyncAction(
    "@@si/contacts-search-profiles/create-started",
    "@@si/contacts-search-profiles/create-succeeded",
    "@@si/contacts-search-profiles/create-failed",
)<void, Profile, FetchError>();

export const updateProfileAsync = createAsyncAction(
    "@@si/contacts-search-profiles/update-started",
    "@@si/contacts-search-profiles/update-succeeded",
    "@@si/contacts-search-profiles/update-failed",
)<void, Profile, FetchError>();

export const deleteProfileAsync = createAsyncAction(
    "@@si/contacts-search-profiles/delete-started",
    "@@si/contacts-search-profiles/delete-succeeded",
    "@@si/contacts-search-profiles/delete-failed",
)<void, Profile["id"], FetchError>();

export const excludeProfileAsync = createAsyncAction(
    "@@si/contacts-search-profiles/exclude-started",
    "@@si/contacts-search-profiles/exclude-succeeded",
    "@@si/contacts-search-profiles/exclude-failed",
)<void, Profile["id"], FetchError>();
